import { LoadingState, ValidationError } from '../../commonTypes'
import { GetAllTechnology, country } from '../CandidateList/CandidateListTypes'

export enum DisplayedCandidateStatusEnum {
  all = 'All',
  offered = 'Offered',
  offeredCancelled = 'Offer Cancelled',
  rejected = 'Rejected',
  new = 'New',
  inProgress = 'In Progress',
  rescheduled = 'Rescheduled',
  hold = 'Hold',
  reprocess = 'Re Process',
  noShow = 'No Show',
  didNotJoin = 'Did not Join',
  joined = 'Joined',
  L1_SHORTLISTED = 'L1_SHORTLISTED',
  L2_SHORTLISTED = 'L2_SHORTLISTED',
  L3_SHORTLISTED = 'L3_SHORTLISTED',
  L4_SHORTLISTED = 'L4_SHORTLISTED',
  L5_SHORTLISTED = 'L5_SHORTLISTED',
  L6_SHORTLISTED = 'L6_SHORTLISTED',
}

export enum OutgoingCandidateStatusEnum {
  offered = 'OFFERED',
  rejected = 'REJECTED',
  new = 'NEW',
  inProgress = 'IN_PROCESS',
  rescheduled = 'RESCHEDULED',
  hold = 'HOLD',
  reprocess = 'REPROCESS',
  noShow = 'NO_SHOW',
  didNotJoin = 'DID_NOT_JOIN',
  joined = 'JOINED',
  offeredCancelled = 'OFFER_CANCELLED',
  L1_SHORTLISTED = 'L1_SHORTLISTED',
  L2_SHORTLISTED = 'L2_SHORTLISTED',
  L3_SHORTLISTED = 'L3_SHORTLISTED',
  L4_SHORTLISTED = 'L4_SHORTLISTED',
  L5_SHORTLISTED = 'L5_SHORTLISTED',
  L6_SHORTLISTED = 'L6_SHORTLISTED',
  all = 'All',
}

export enum OutgoingCandidateSelectionStatusEnum {
  today = 'Today',
  yesterday = 'Yesterday',
  thisWeek = 'This Week',
  lastWeek = 'Last Week',
  lastMonth = 'Last Month',
  currentMonth = 'Current Month',
  custom = 'Custom',
}

export enum CandidateDateFilterEnum {
  fromDate = 'From Date',
  toDate = 'To Date',
}

export enum CandidateCheckBoxFilterEnum {
  searchByExperience = 'Search By Experience',
  multipleSearch = 'Multiple Search',
  searchByRecruiterName = 'Search By Recruiter Name',
  searchBySourceName = 'Search By Source Name',
}

export interface OutgoingStatusReportFilterOptions {
  candidateStatus: string
  endIndex: number
  searchByCandidateName: string
  searchByExperience: boolean
  searchByMultipleFlag: boolean
  searchByRecruiterName: boolean
  searchBySourceName: boolean
  selectionCountry: string | number //if nothing entered then string else number
  selectionStatus: string
  selectionTechnology: string
  startIndex: number
  fromDate: string | null
  toDate: string | null
}

export interface IncomingStatusReportItem {
  interviewDate: string
  candidateName: string
  contactNumber: string
  emailId: string
  technology: string
  experiance: string
  status: string
  candidateId: number
  timeLineStatus: null
  recruiter: string
  source: string
  interviewResultStatus: null | string
  interviewerName: string | null
  interviewRound: number
}

export interface IncomingInterviewStatusReport {
  size: number
  list: IncomingStatusReportItem[]
}

export interface CandidateChartDetails {
  caption: string
  subcaption: string
  plottooltext: string
  theme: string
  xAxisName: string
  yAxisName: string
  labelDisplay: string
  slantLabel: string
}

export interface CandidateStatusChartLabelData {
  label: string
  value: number
  labelName: null
}

export interface IncomingCandidateStatusChart {
  chart: CandidateChartDetails
  data: CandidateStatusChartLabelData[]
}

export interface InterviewStatusReportSliceState {
  isLoading: LoadingState
  error: ValidationError
  allEmpCountries: country[]
  allTechnology: GetAllTechnology[]
  filterOptions: OutgoingStatusReportFilterOptions
  interviewStatusReportList: IncomingInterviewStatusReport
  candidateStatusChart: IncomingCandidateStatusChart
  isLoadingInterview: LoadingState
}

export interface ExportInterviewStatusReportParams {
  candidateStatus: string
  selectionStatus: string
  selectionTechnology: string
  fromDate: string | undefined
  toDate: string | undefined
  searchByCandidateName: string
  searchByMultipleFlag: boolean
  searchByRecruiterName: boolean
  searchBySourceName: boolean
}

export interface ExportInterviewerDetailsParams {
  fromDate: string | undefined
  toDate: string | undefined
  selectionStatus: string
}

export interface CandidateStatusChartParams {
  from: string
  to: string
  dateSelection: string
}
